import { Button } from "@src/appV2/redesign/components/Button";
import { Pill } from "@src/appV2/redesign/components/Pill";
import { Text } from "@src/appV2/redesign/components/Text";

interface AccountSwitcherOptionMobileProps {
  title: string;
  subtitles?: string[];
  stage?: string;
  onClick?: () => void;
}

export function AccountSwitcherOptionMobile(props: AccountSwitcherOptionMobileProps) {
  const { title, subtitles, stage, onClick } = props;

  return (
    <Button
      fullWidth
      sx={{
        height: "auto",
        flexDirection: "column",
        alignItems: "start",
      }}
      variant="outlined"
      onClick={onClick}
    >
      <Text
        variant="body2"
        sx={(theme) => ({
          color: theme.palette.navbar?.gradient,
          fontWeight: 500,
        })}
      >
        {title}
      </Text>
      {subtitles?.map((subtitle) => (
        <Text
          key={subtitle}
          variant="body2"
          sx={(theme) => ({
            color: theme.palette.navbar?.gradient,
          })}
        >
          {String(subtitle)}
        </Text>
      ))}

      {stage && <Pill>{stage}</Pill>}
    </Button>
  );
}
